/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleCutIcon24Solid = forwardRef('CheckCircleCutIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 22c5.523 0 10-4.477 10-10a9.96 9.96 0 0 0-.976-4.314l-7.577 7.578a3.125 3.125 0 0 1-4.42 0l-2.986-2.987a1.25 1.25 0 0 1 1.767-1.768l2.987 2.987c.244.244.64.244.884 0l7.955-7.955A9.978 9.978 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10Z" })));
});
